import {ToolName} from '../../../copilot.enums';

export default function buildKnowledgeRAGToolName(suffix?: string): string {
  return suffix ? `${ToolName.AskKnowledgeRAG}-${suffix}` : ToolName.AskKnowledgeRAG;
}
